const viewportCalculator = (screenWidth, percentage) => {
  return `${(screenWidth * percentage) / 100}px`;
};

export default viewportCalculator;
